import { render, staticRenderFns } from "./CartSidebar.vue?vue&type=template&id=6fd6860a&scoped=true"
import script from "./CartSidebar.vue?vue&type=script&lang=ts"
export * from "./CartSidebar.vue?vue&type=script&lang=ts"
import style0 from "./CartSidebar.vue?vue&type=style&index=0&id=6fd6860a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd6860a",
  null
  
)

export default component.exports